import { orderStatusHeaderStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader";
import { COLORS } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(orderStatusHeaderStyles, {
    container: {
        gap: 5,
        css: css`
            border-top: 1px solid ${COLORS.border.base};
            padding-top: 30px;
            margin-bottom: 10px;
        `,
    },
    titleGridItem: {
        width: [10, 10, 7, 7, 7],
        css: css`
            align-items: center;
        `,
    },
    printButton: {
        variant: "secondary",
        css: css`
            margin-left: 10px;
        `,
    },
});
